import React from 'react';
import PropTypes from 'prop-types';

const MainSection = ({
  title, children, className = '', id = '',
}) => {
  return (
    <section id={id} className={className} data-testid="main-section">
      <h2
        className="heading-01"
        style={{
          position: 'relative',
          paddingTop: '0.625rem',
          marginBottom: (className === 'multi-media-gallery' || className === 'payment-information' || className === 'billing-information') ? '0px' : '25px',
        }}
      >
        <span className="accent-bar" data-testid="accent-bar" />
        {title}
      </h2>
      {children}
    </section>
  );
};

MainSection.propTypes = {
  title: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  id: PropTypes.string,
};

export default MainSection;
